<div class="main">
  <app-navbar *ngIf="isLoggedIn" class="top-bar"></app-navbar>
  <div *ngIf="showLoader" class="loader_main">
    <div class="loader"></div>
  </div>
  <router-outlet (activate)="onActivate()" class="content"></router-outlet>
</div>
